module.exports = __webpack_public_path__ + "a80d0e1adbaec4406c61d6a42449c9eb.png";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/reports/credit-card-icon.png
// module id = 928
// module chunks = 0